import React from "react"
import Relay from "react-relay"
import { Link, withRouter } from "react-router"
import Helmet from "react-helmet"
import classNames from "classnames"
import auth from "../../auth"
import { trackEvent } from "../../analyticsAndSocial"
import { setToken } from "../../actions"
import { dispatch } from "../../Dispatcher"
import { userSetFragment } from "../modules/AddToSet"
import { FormattedMessage, injectIntl } from "react-intl"
import sharedMessages from "../../messages/index"
import profileMessages from "../../messages/profile"
import settingsMessages from "../../messages/settings"
import State from "../../stores/State"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"

class Login extends React.Component {
  state = {
    email: "",
    password: "",
    loading: false,
    errors: {},
    locale: State.get("locale")
  }

  changeField = evt => {
    if (evt) evt.preventDefault()

    const { value, name } = evt.target
    this.setState({
      [name]: value
    })
  }

  componentDidMount() {
    this._stateListener = State.addListener(() => {
      const locale = State.get("locale")
      if (locale !== this.state.locale) {
        this.setState({
          locale
        })
      }
    })
  }

  componentWillUnmount() {
    if (this._stateListener) {
      this._stateListener.remove()
    }
  }

  onSubmit = evt => {
    if (evt) evt.preventDefault()

    const {
      router,
      location: { query, hash },
      relay,
      intl
    } = this.props
    const { email: username, password } = this.state
    this.setState({ loading: true })

    auth
      .checkRegistration(username)
      .then(data => {
        if (data.status === 401) {
          throw Error()
        }

        auth
          .authenticate({ username, password })
          .then(token => {
            this.setState({ loading: false, errors: {} })
            dispatch(setToken(token))
            trackEvent("user", "login")
          })
          .then(
            () =>
              new Promise((resolve, reject) => {
                // force clear relay cache of user sets
                relay.forceFetch(null, ({ done, error }) => {
                  if (done) {
                    resolve(done)
                  } else if (error) {
                    reject(error)
                  }
                })
              })
          )
          .then(() => {
            const redirectUrl = query.redirectUrl
              ? `${query.redirectUrl}${hash}`
              : null
            const next = query.next || redirectUrl || null
            router.push(next || "/search")
          })
          .catch(err => {
            this.setState({
              errors: err.json || {
                error: intl.formatMessage(sharedMessages.somethingWentWrong)
              },
              loading: false
            })
          })
      })
      .catch(() =>
        this.setState({
          errors: {
            error: intl.formatMessage(profileMessages.errorUserOrPass)
          },
          loading: false
        })
      )
  }

  onPasswordReset = evt => {
    if (evt) evt.preventDefault()
  }

  render() {
    const { intl } = this.props
    const { email, password, errors, loading, locale } = this.state
    const accountSettings = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )
    const styleBodyType = accountSettings.settings.style.content || ""

    return (
      <main id="main" role="main" tabIndex={0} data-componant="Login">
        {getStyleTag(["button--lowlight", "form-message"])}
        <Helmet title={intl.formatMessage(profileMessages.logIn)} />
        {styleBodyType !== "default" ? (
          <div className="title" style={getStyles("p-offpage__title")}>
            Sign into your Account
          </div>
        ) : null}
        <div className="small-12 columns auth__main-column">
          <form
            onSubmit={this.onSubmit}
            className={classNames("login-form form--can-load", {
              "state-form-loading": loading
            })}
            style={getStyles("p-offpage__login__form")}
          >
            <input
              type="text"
              name="email"
              value={email}
              onChange={this.changeField}
              placeholder={`${intl.formatMessage(sharedMessages.email)}${
                styleBodyType === "default" ? "" : "*"
              }`}
              required
            />
            <input
              type="password"
              name="password"
              value={password}
              onChange={this.changeField}
              placeholder={`${intl.formatMessage(profileMessages.password)}${
                styleBodyType === "default" ? "" : "*"
              }`}
              required
            />
            {errors.error === "invalid_grant" && (
              <div className="form-message state-error">
                <FormattedMessage {...profileMessages.errorUserOrPass} />
              </div>
            )}
            {errors.error &&
              errors.error !== "invalid_grant" && (
                <div className="form-message state-error">{errors.error}</div>
              )}
            {locale === "mi" && (
              <div
                className="actions vertical-align-middle"
                style={getStyles("p-offpage__actions")}
              >
                <button
                  className={classNames("button man button--can-load", {
                    "state-loading": loading
                  })}
                  type="submit"
                  style={getStyles("p-offpage__form__button")}
                >
                  <FormattedMessage {...sharedMessages.buttonLogIn} />
                </button>
                {styleBodyType === "default" && (
                  <div className="inline-block">
                    {" "}
                    <Link
                      to={{
                        pathname: "/register",
                        query: this.props.location.query
                      }}
                    >
                      <button
                        className={classNames(
                          "button button--lowlight-alt man button--can-load"
                        )}
                        type="button"
                      >
                        <FormattedMessage {...profileMessages.register} />
                      </button>
                    </Link>
                    <strong className="mls mrs">
                      <FormattedMessage {...profileMessages.or} />
                    </strong>
                  </div>
                )}
              </div>
            )}
            {locale !== "mi" && (
              <div
                className="actions vertical-align-middle"
                style={getStyles("p-offpage__actions")}
              >
                <button
                  className={classNames("button man button--can-load", {
                    "state-loading": loading
                  })}
                  type="submit"
                  style={getStyles("p-offpage__form__button")}
                >
                  <FormattedMessage {...sharedMessages.buttonLogIn} />
                </button>
                {styleBodyType === "default" && (
                  <div className="inline-block">
                    <strong className="mls mrs">
                      <FormattedMessage {...profileMessages.or} />
                    </strong>
                    <Link
                      to={{
                        pathname: "/register",
                        query: this.props.location.query
                      }}
                    >
                      <button
                        className="button button--lowlight-alt man button--can-load"
                        type="button"
                      >
                        <FormattedMessage {...profileMessages.register} />
                      </button>
                    </Link>
                  </div>
                )}
              </div>
            )}
            <div
              className={`links links--dark small mts ${styleBodyType ===
                "default" && "links--underline"}`}
              style={getStyles("p-offpage__links")}
            >
              <Link to="/reset-password">
                <strong>
                  <FormattedMessage {...profileMessages.forgottenPassword} />
                </strong>
              </Link>
            </div>
          </form>
        </div>
        {styleBodyType !== "default" && (
          <div
            className="bottom-links"
            style={getStyles("p-offpage__bottom__links")}
          >
            <span style={getStyles("p-offpage__bottom__links__text")}>
              Don’t have an account?
            </span>
            <Link
              to={{ pathname: "/register", query: this.props.location.query }}
              style={getStyles("p-offpage__bottom__link")}
            >
              {/* <FormattedMessage {...profileMessages.register} /> */}
              Register Now
            </Link>
          </div>
        )}
      </main>
    )
  }
}

export default Relay.createContainer(withRouter(injectIntl(Login)), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        user_sets(first: 100) {
          edges {
            node {
              ${userSetFragment}
            }
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/Login.js